export default "__VITE_ASSET__C1FG8RSG__"